import { combineEpics, ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, filter, map, mergeMap, takeUntil } from 'rxjs/operators'

import { URL_CONST } from 'utils/urlConsts'
import { matchURL } from 'utils/urls'

import { selectHasSelectedCompanyFilterAccess } from 'containers/App/selectors'
import { DATE_FILTER_CHANGE, SCANBACK_CHANGE } from 'containers/Dashboard/Home/constants'
import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from 'containers/PartnerOptions/constants'

import { selectDateRange, selectWithoutScanback } from '../selectors'

import {
  fetchDataError,
  fetchDataSuccess,
  fetchInspectedCountError,
  fetchInspectedCountSuccess,
} from './actions'
import { DATA_REQUEST_ASYNC, INSPECTED_COUNT_REQUEST_ASYNC } from './constants'

const fetchDataEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(
      DATA_REQUEST_ASYNC.INITIATE,
      FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS,
      DATE_FILTER_CHANGE,
      SCANBACK_CHANGE
    ),
    filter((action) => {
      if (
        action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS ||
        action.type === SCANBACK_CHANGE
      )
        return matchURL(URL_CONST.dashboard.home)
      return true
    }),
    // companyFilter 403s unless the user can swap into the selected company.
    // A loaded brand child can still be rejected. Cancel resets the loader;
    // FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS re-fires this.
    mergeMap(() =>
      !selectHasSelectedCompanyFilterAccess(state$.value)
        ? of(DATA_REQUEST_ASYNC.cancel())
        : api.dashboard
            .getEmailsOverviewData(
              state$.value.partnerOptions.selectedCompany?.value,
              selectDateRange(state$.value),
              selectWithoutScanback(state$.value)
            )
            .pipe(
              map((response) => fetchDataSuccess(response?.response)),
              catchError((error) => of(epicsErrorHandler(fetchDataError, error))),
              takeUntil(action$.pipe(ofType(DATA_REQUEST_ASYNC.CANCEL)))
            )
    )
  )

const fetchInspectedCountEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(
      INSPECTED_COUNT_REQUEST_ASYNC.INITIATE,
      FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS,
      DATE_FILTER_CHANGE,
      SCANBACK_CHANGE
    ),
    filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return matchURL(URL_CONST.dashboard.home)
      return true
    }),
    // Same swap gate as the overview request above.
    mergeMap(() =>
      !selectHasSelectedCompanyFilterAccess(state$.value)
        ? of(INSPECTED_COUNT_REQUEST_ASYNC.cancel())
        : api.dashboard
            .getEmailsOverviewInspectedCount(
              state$.value.partnerOptions.selectedCompany?.value,
              selectDateRange(state$.value),
              selectWithoutScanback(state$.value)
            )
            .pipe(
              map((response) => fetchInspectedCountSuccess(response.response)),
              catchError((error) => of(epicsErrorHandler(fetchInspectedCountError, error))),
              takeUntil(action$.pipe(ofType(INSPECTED_COUNT_REQUEST_ASYNC.CANCEL)))
            )
    )
  )

export default combineEpics(fetchDataEpic, fetchInspectedCountEpic)
